module.exports = __webpack_public_path__ + "static/media/Coin.41999889.svg";